<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-12">
				<div class="box">
					<div>
						<label>{{ $t('client_area.contract_privacy.messages_language_selector') }}</label>
						<e-select
							v-model="active_language"
							track-by="id"
							label="name"
							:options="language_options"
							:searchable="false"
							:show-labels="false"
							:allow-empty="false"
						>
						</e-select>
					</div>

					<div class="pt-4">
						<label>{{ $t('menu.client_area.settings.welcome_message') }}</label>
						<e-editor-froala
							v-if="data_loaded"
							:key="`welcome_${active_language.id}`"
							identifier="welcome_message_single_lang"
							:content="welcome_message_current"
							@change="onWelcomeMessageChange"
							:moreText="[ 'bold', 'italic', 'underline', 'strikeThrough', 'formatUL', 'formatOL', 'clearFormatting', 'undo', 'redo' ]"
						></e-editor-froala>
					</div>

					<div class="pt-4">
						<label>{{ $t('menu.client_area.settings.contact_us') }}</label>
						<e-editor-froala
							v-if="data_loaded"
							:key="`contact_${active_language.id}`"
							identifier="contact_us_single_lang"
							:content="contactus_current"
							@change="onContactUsChange"
							:moreText="[ 'bold', 'italic', 'underline', 'strikeThrough', 'formatUL', 'formatOL', 'clearFormatting', 'undo', 'redo' ]"
						></e-editor-froala>
					</div>

					<div class="pt-4" v-if="isFrenchActive">
						<label>{{ $t('client_area.contact_us.openhours') }}</label>
						<div v-for="(hours, idx) in openDays" :key="idx" class="mt-1">
							<b-input-group :prepend="day_names[idx]">
								<b-form-input
									:value="openDays[idx]"
									@input="$set(openDays, idx, $event)"
									placeholder="09:00-12:00, 14:00-18:00"
								></b-form-input>
							</b-input-group>
						</div>
					</div>

					<div class="pt-4">
						<label>{{ $t('menu.client_area.settings.cgu_cgv') }}</label>

						<b-input-group :key="`privacy_content_${active_language.id}`" :prepend="getTrad('client_area.contract_privacy.contract_validation')">
							<b-form-input
								class="mr-1"
								v-model="privacy_policy_content_current"
								:placeholder="isFrenchActive ? 'ex: En cochant cette case, vous acceptez nos conditions générales.' : 'ex: By checking this box, you accept our terms and conditions.'"
							></b-form-input>
						</b-input-group>

						<b-input-group class="mt-2" :key="`cgv_link_${active_language.id}`" :prepend="getTrad('client_area.contract_privacy.cgv_link')">
							<b-form-input
								class="mr-1"
								v-model="cgv_link_current"
								:placeholder="isFrenchActive ? 'ex: https://monsite.fr/cgv' : 'ex: https://mysite.com/terms'"
							></b-form-input>
						</b-input-group>

						<b-input-group class="mt-2" :key="`privacy_link_${active_language.id}`" :prepend="getTrad('client_area.contract_privacy.link_privacy_policy')">
							<b-form-input
								class="mr-1"
								v-model="privacy_link_current"
								:placeholder="isFrenchActive ? 'ex: https://monsite.fr/confidentialite' : 'ex: https://mysite.com/privacy'"
							></b-form-input>
						</b-input-group>

						<b-input-group class="mt-2" :key="`message_conditions_${active_language.id}`" :prepend="getTrad('client_area.contract_privacy.message_no_condition')">
							<b-form-input
								class="mr-1"
								v-model="message_conditions_current"
								:placeholder="isFrenchActive ? 'ex: Aucune condition disponible pour cet étalon.' : 'ex: No conditions available for this stallion.'"
							></b-form-input>
						</b-input-group>
					</div>

					<div class="mt-4 col-12">
						<div class="form-group text-center">
							<button class="btn btn-primary" :disabled="saving" @click="save">
								{{ $t('global.sauvegarder') }}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	import _defaults from 'lodash/defaults'
	import Contract from "@/mixins/Contract.js"

	export default {
		name: "ContractMessagesCustomization",
		mixins: [Contract],
		data() {
			return {
				saving: false,
				data_loaded: false,
				active_language: { id: 'fr', name: 'FR' },
				welcome_message_fr: '',
				welcome_message_en: '',
				contactus_fr: '',
				contactus_en: '',
				openDays: ['', '', '', '', '', '', ''],
				privacy_policy_content: '',
				privacy_policy_content_en: '',
				cgv_link: '',
				cgv_link_en: '',
				privacy_link: '',
				privacy_link_en: '',
				message_conditions: '',
				message_conditions_en: '',
			}
		},
		computed: {
			language_options() {
				return [
					{ id: 'fr', name: 'FR' },
					{ id: 'en', name: 'EN' },
				]
			},
			isFrenchActive() {
				return this.active_language && this.active_language.id === 'fr'
			},
			day_names() {
				return this.$t('client_area.contact_us.days')
			},
			welcome_message_current: {
				get() {
					return this.isFrenchActive ? this.welcome_message_fr : this.welcome_message_en
				},
				set(val) {
					if (this.isFrenchActive) {
						this.welcome_message_fr = val
					} else {
						this.welcome_message_en = val
					}
				}
			},
			contactus_current: {
				get() {
					return this.isFrenchActive ? this.contactus_fr : this.contactus_en
				},
				set(val) {
					if (this.isFrenchActive) {
						this.contactus_fr = val
					} else {
						this.contactus_en = val
					}
				}
			},
			privacy_policy_content_current: {
				get() {
					return this.isFrenchActive ? this.privacy_policy_content : this.privacy_policy_content_en
				},
				set(val) {
					if (this.isFrenchActive) {
						this.privacy_policy_content = val
					} else {
						this.privacy_policy_content_en = val
					}
				}
			},
			cgv_link_current: {
				get() {
					return this.isFrenchActive ? this.cgv_link : this.cgv_link_en
				},
				set(val) {
					if (this.isFrenchActive) {
						this.cgv_link = val
					} else {
						this.cgv_link_en = val
					}
				}
			},
			privacy_link_current: {
				get() {
					return this.isFrenchActive ? this.privacy_link : this.privacy_link_en
				},
				set(val) {
					if (this.isFrenchActive) {
						this.privacy_link = val
					} else {
						this.privacy_link_en = val
					}
				}
			},
			message_conditions_current: {
				get() {
					return this.isFrenchActive ? this.message_conditions : this.message_conditions_en
				},
				set(val) {
					if (this.isFrenchActive) {
						this.message_conditions = val
					} else {
						this.message_conditions_en = val
					}
				}
			},
		},
		created() {
			this.init_component()
		},
		methods: {
			onWelcomeMessageChange(event) {
				this.welcome_message_current = event.val
			},
			onContactUsChange(event) {
				this.contactus_current = event.val
			},
			async init_component() {
				const [privacy, welcome, contact] = await Promise.all([
					this.getCaContractPrivacyPolicy(),
					this.getCaWelcomeMessage(),
					this.getCaContactUs(),
				])

				const privacyData = _defaults(privacy || {}, {
					privacy_policy_content: '',
					privacy_policy_content_en: '',
					cgv_link: '',
					cgv_link_en: '',
					privacy_link: '',
					privacy_link_en: '',
					message_conditions: '',
					message_conditions_en: '',
				})

				this.privacy_policy_content = privacyData.privacy_policy_content
				this.privacy_policy_content_en = privacyData.privacy_policy_content_en
				this.cgv_link = privacyData.cgv_link
				this.cgv_link_en = privacyData.cgv_link_en
				this.privacy_link = privacyData.privacy_link
				this.privacy_link_en = privacyData.privacy_link_en
				this.message_conditions = privacyData.message_conditions
				this.message_conditions_en = privacyData.message_conditions_en

				this.welcome_message_fr = welcome.welcome_message_fr || ''
				this.welcome_message_en = welcome.welcome_message_en || ''

				this.contactus_fr = contact.contactus_fr || ''
				this.contactus_en = contact.contactus_en || ''
				this.openDays = Array.isArray(contact.openDays) ? contact.openDays : ['', '', '', '', '', '', '']

				this.data_loaded = true
			},

			async save() {
				this.saving = true
				try {
					// Préparer tous les paramètres dans des objets structurés
					const privacyData = {
						privacy_policy_content: this.privacy_policy_content,
						privacy_policy_content_en: this.privacy_policy_content_en,
						cgv_link: this.cgv_link,
						cgv_link_en: this.cgv_link_en,
						privacy_link: this.privacy_link,
						privacy_link_en: this.privacy_link_en,
						message_conditions: this.message_conditions,
						message_conditions_en: this.message_conditions_en,
					}

					const welcomeData = {
						welcome_message_fr: this.welcome_message_fr,
						welcome_message_en: this.welcome_message_en,
					}

					const contactData = {
						contactus_fr: this.contactus_fr,
						contactus_en: this.contactus_en,
						openDays: this.openDays,
					}

					// Un seul appel API pour tout (batch)
					await this.saveCaContractMessagesBatch(privacyData, welcomeData, contactData)

					this.successToast()
				} finally {
					this.saving = false
				}
			},
		}
	}
</script>
